import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthApiEffects } from './auth-api.effects';
import * as authWorkspaceEffects from './auth-workspace.effects';
import * as authEffects from './auth.effects';
import { authFeature } from './auth.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(authFeature),
    EffectsModule.forFeature([authEffects, authWorkspaceEffects, AuthApiEffects]),
  ],
})
export class AuthStateModule {}
